<!--
 * @Author: liushengjiang 1947448287@qq.com
 * @Date: 2021-12-28 15:26:11
 * @LastEditors: liushengjiang 1947448287@qq.com
 * @LastEditTime: 2023-09-01 10:25:28
 * @FilePath: \petro-web-chemicals-buyerc:\Users\Administrator\Desktop\买家app\petro-app-chemicals-buyer\src\views\login\components\Header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="logo-wrap">
      <img class="img-logo" src="@/assets/imgs/logo3.png" />
      <router-link v-if="showAccount" class="register-link" to="/register">立即注册</router-link>
    </div>
    <div class="title">
      登录
    </div>
    <div class="tips">
      请登录中油e化提供的账户<br/>
      和密码或手机号
    </div>
  </div>
</template>
<script>
export default {
  name: "Logo",
  props: {
    showAccount: Boolean,
  },
};
</script>
<style lang="stylus" scoped>
.logo-wrap
  margin-top 64px
  padding 0 20px
  display flex
  justify-content space-between
  align-items center
  height 146px
  .img-logo
    width 372px
    height 114px
.register-link
  width 160px
  height: 28px;
  color: rgba(0, 0, 0, 1);
  font-size: 28px;
  font-weight bold
  font-family: AlibabaPuHuiTi_2_65_Medium;
  letter-spacing 3px
.title
  margin-top 32px
  padding 0 42px
  height 96px
  line-height 96px
  color rgba(30, 31, 32, 1)
  font-size 60px
  text-align left
  font-family PingFangSC-Semibold
  font-weight bold
  letter-spacing 3px
.tips
  padding 0 42px
  margin-top 16px
  height 76px
  line-height 38px
  color rgba(118, 123, 127, 1)
  font-size 28px
  letter-spacing 2px
  text-align left
  font-family PingFangSC-Medium
</style>
